import * as React from 'react'
import { GridColDef, GridColumnVisibilityModel } from '@mui/x-data-grid-pro'
import {
  ageValueFormatter,
  GridEmailLink,
  GridLink,
  GridPhoneLink,
  SortConfig,
} from '@user/components/xGrid'

export const draftLeadColumns = (
  knockStatusEnabled: boolean = false,
): GridColDef[] => [
  {
    field: 'contactName',
    headerName: 'Lead Name',
    width: 150,
    renderCell: ({ row, value }) => (
      <GridLink
        label={value as string}
        href={'/#/leads/addLead?draftId=' + row.id}
      />
    ),
  },
  {
    field: 'street1',
    headerName: 'Address',
    width: 130,
    sortable: false,
  },
  {
    field: 'createdTime',
    headerName: 'Age',
    valueFormatter: ageValueFormatter,
  },
  { field: 'branch', headerName: 'Branch' },
  { field: 'campaign', headerName: 'Campaign' },
  {
    field: 'id',
    headerName: 'Date Submitted',
    valueGetter: ({ row }) => row.createdTime,
    type: 'date',
    width: 160,
  },
  {
    field: 'emailAddress',
    headerName: 'Email',
    width: 130,
    sortable: false,
    renderCell: ({ value }) => <GridEmailLink value={value} />,
  },
  {
    field: 'phoneNumber',
    headerName: 'Phone',
    width: 130,
    sortable: false,
    renderCell: ({ row }) => (
      <GridPhoneLink phone={row.phoneNumber} ext={row.phoneExt} />
    ),
  },
  { field: 'source', headerName: 'Source' },
  { field: 'userName', headerName: 'Submitted By', width: 130 },
  { field: 'type', headerName: 'Type', width: 110 },
  ...(knockStatusEnabled
    ? [
        {
          field: 'knockStatus',
          headerName: 'Current Knock Status',
          width: 200,
        },
        {
          field: 'knockStatusReason',
          headerName: 'Knock Status Reason',
          width: 180,
        },
      ]
    : []),
]

export const lockedDraftLeadColumns = ['contactName']

export const defaultDraftLeadColVis =
  draftLeadColumns().reduce<GridColumnVisibilityModel>(
    (acc, { field }) => ({ ...acc, [field]: true }),
    {},
  )

export const defaultDraftLeadColumns = draftLeadColumns().map((c) => c.field)

export const draftLeadSortConfig: SortConfig = {
  createdTime: { column: 'id', tiebreakers: ['id'] },
}
